import { Display, List } from "stentor-models";

export function isCarousel(display: Display): display is List {
    return !!display && ((display as List).type === "CAROUSEL");
}